const getLocalStorage = (key) => localStorage.getItem(key);

const useLocalStorage = (key) => getLocalStorage(key) ?? localStorage.setItem(key, 'empty key');

export { useLocalStorage };
